import { FareGroupOption, FareGroupVariant } from '../../../../model/types';
import React, { FC } from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../../../theme';
import GridOption from '../GridOption/GridOption';

export interface Props {
	className?: string;
	variant: FareGroupVariant;
	options: FareGroupOption[];
}

const GridOptions: FC<Props> = ({ className, variant, options }) => {
	const { GridOptions: css } = useTheme('Entities').FareGroupV2;

	return (
		<div className={cn(css.root, className, css[variant])}>
			{options.map((option, index) => (
				<GridOption key={index} className={css.option} variant={variant} {...option} />
			))}
		</div>
	);
};

export default GridOptions;
